module.exports = {"twitterTweet":{"content":[{"field":"status","constraints":{"maxLength":280}}],"media":{"allowedCombination":"one","static":{"min":0,"max":4},"dynamic":{"min":0,"max":1}}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurations/channels/contentConstraints.json
// module id = LXtD
// module chunks = 53